// @ts-nocheck
/**
 * Rubina Irfan — Header
 * Mega menu hover/position + multi-level slide mobile drawer
 * Complete rebuild — no accordions
 */
(function () {
  "use strict";

  var header = document.getElementById("ri-header");
  var megaItems = document.querySelectorAll(".ri-nav__item.has-mega");
  var burger = document.querySelector(".ri-nav__burger");
  var drawer = document.getElementById("ri-drawer");
  var closeBtn = document.querySelector(".ri-drawer__close");
  var backBtn = document.querySelector("[data-drawer-back]");
  var backdrop = document.querySelector(".ri-drawer__backdrop");

  var enterTimer = null;
  var leaveTimer = null;
  var ENTER_DELAY = 80;
  var LEAVE_DELAY = 130;

  /* ─── SCROLL SHADOW ─── */
  function onScroll() {
    if (!header) return;
    header.classList.toggle("ri-nav--scrolled", window.scrollY > 40);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ─── MEGA MENUS ───
     Several nav links can each own a panel, so nothing is looked up by a single
     hardcoded id: .ri-nav__item carries data-mega-panel pointing at its own
     .ri-mega element. Opening one closes whichever was open.

     Opens on hover and on keyboard focus, keeps aria-expanded truthful, and
     closes when focus leaves both the trigger and the panel. */
  if (megaItems.length) {
    var activeItem = null;
    var activePanel = null;

    function panelOf(item) {
      return item ? document.getElementById(item.dataset.megaPanel) : null;
    }

    /* The panel is position:fixed, so its top has to track the bottom of the
       header — which moves when the announcement bar scrolls away or the
       viewport resizes. Repositioning only on open left an open panel
       detached from the header. */
    function positionMega() {
      if (!header || !activePanel) return;
      activePanel.style.top = Math.round(header.getBoundingClientRect().bottom) + "px";
    }

    function openMega(item) {
      var panel = panelOf(item);
      if (!panel) return;
      if (activePanel && activePanel !== panel) closeMega();

      activeItem = item;
      activePanel = panel;
      positionMega();
      panel.classList.add("is-open");
      panel.setAttribute("aria-hidden", "false");
      item.classList.add("is-active");

      var trigger = item.querySelector("[data-mega-trigger]");
      if (trigger) trigger.setAttribute("aria-expanded", "true");
    }

    function closeMega() {
      if (activePanel) {
        activePanel.classList.remove("is-open");
        activePanel.setAttribute("aria-hidden", "true");
      }
      megaItems.forEach(function (i) {
        i.classList.remove("is-active");
        var t = i.querySelector("[data-mega-trigger]");
        if (t) t.setAttribute("aria-expanded", "false");
      });
      activeItem = null;
      activePanel = null;
    }

    function isOpen() {
      return activePanel !== null;
    }

    window.addEventListener("scroll", positionMega, { passive: true });
    window.addEventListener("resize", positionMega);

    megaItems.forEach(function (item) {
      var panel = panelOf(item);
      if (!panel) return;

      item.addEventListener("mouseenter", function () {
        clearTimeout(leaveTimer);
        enterTimer = setTimeout(function () {
          openMega(item);
        }, ENTER_DELAY);
      });
      item.addEventListener("mouseleave", function () {
        clearTimeout(enterTimer);
        leaveTimer = setTimeout(closeMega, LEAVE_DELAY);
      });

      /* Keyboard: focusing the trigger opens the panel immediately. */
      item.addEventListener("focusin", function () {
        clearTimeout(leaveTimer);
        openMega(item);
      });

      panel.addEventListener("mouseenter", function () {
        clearTimeout(leaveTimer);
      });
      panel.addEventListener("mouseleave", function () {
        clearTimeout(enterTimer);
        leaveTimer = setTimeout(closeMega, LEAVE_DELAY);
      });
      panel.addEventListener("focusin", function () {
        clearTimeout(leaveTimer);
      });
    });

    /* Tabbing past the last link in the panel (or away from the trigger) closes
       it. relatedTarget is where focus is heading. */
    document.addEventListener("focusout", function (e) {
      if (!isOpen()) return;
      var next = e.relatedTarget;
      if (!next) return;
      if (activePanel.contains(next)) return;
      if (next.closest && next.closest(".ri-nav__item.has-mega")) return;
      closeMega();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !isOpen()) return;
      /* Return focus to the trigger that opened it, per the disclosure pattern. */
      var trigger = activeItem && activeItem.querySelector("[data-mega-trigger]");
      var inPanel = activePanel.contains(document.activeElement);
      closeMega();
      if (trigger && inPanel) trigger.focus();
    });
  }

  /* ─── MOBILE DRAWER — Multi-level slide ─── */
  var panelMap = {};
  var history = ["main"];

  document.querySelectorAll(".ri-drawer__panel").forEach(function (el) {
    panelMap[el.dataset.panel] = el;
  });

  // Activate main panel on init
  if (panelMap["main"]) panelMap["main"].dataset.state = "active";

  /* Open/close drawer */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    if (burger) burger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    if (burger) burger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    // Reset to main panel after slide-out animation
    setTimeout(resetToMain, 400);
    if (burger) burger.focus();
  }

  function resetToMain() {
    history = ["main"];
    Object.values(panelMap).forEach(function (p) {
      delete p.dataset.state;
    });
    if (panelMap["main"]) panelMap["main"].dataset.state = "active";
    syncBackBtn();
  }

  /* Forward navigation */
  function goTo(targetId) {
    var currentId = history[history.length - 1];
    var current = panelMap[currentId];
    var target = panelMap[targetId];
    if (!target) return;

    if (current) current.dataset.state = "prev";
    target.dataset.state = "active";
    target.scrollTop = 0;
    history.push(targetId);
    syncBackBtn();
  }

  /* Back navigation */
  function goBack() {
    if (history.length <= 1) return;
    var currentId = history.pop();
    var current = panelMap[currentId];
    var prevId = history[history.length - 1];
    var prev = panelMap[prevId];

    // Current slides out to the right (remove state → default translateX(100%))
    if (current) delete current.dataset.state;
    // Previous slides back from left (-28% → 0)
    if (prev) prev.dataset.state = "active";
    syncBackBtn();
  }

  /* Show/hide the back button */
  function syncBackBtn() {
    if (!backBtn) return;
    backBtn.hidden = history.length <= 1;
  }

  /* Delegated click: panel triggers */
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-drawer-trigger]");
      if (trigger) {
        e.preventDefault();
        goTo(trigger.dataset.drawerTrigger);
      }
    });
  }

  /* Back button */
  if (backBtn) backBtn.addEventListener("click", goBack);

  /* Open / close wiring */
  if (burger) burger.addEventListener("click", openDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  if (backdrop) backdrop.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  /* ─── CART COUNT ─── */
  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  document.addEventListener("ri:cart:updated", updateCartCount);
  document.addEventListener("cart:updated", updateCartCount);
})();
